import '../../resources/css/frame/MainHeader.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import { Nav, NavDropdown} from 'react-bootstrap';
import { doLogout, forwardForgotPwd } from '../../actions/login/index';
import { initModalCallback } from '../../actions/index';


class MainHeader extends Component {

  constructor(props) {
    super(props);

    // bind this props to function
    this.toResetPasswrod = this.toResetPasswrod.bind(this);
  };

  toResetPasswrod = () => {
    const { history } = this.props;

    // to reset password page
    if (history) {
      history.push("/Main/ResetPassword");
    }
  }

  toLogout = () => {
    const { history, doLogout } = this.props;

    // to reset password page
    if (history) {
      doLogout();
      history.push("/");
    }
  }

  render() {
    const { name } = this.props;
    let shortFirstChar = '';

    if (name) {
      shortFirstChar = name.substring(0, 1).toUpperCase();
    }

    return (
      <Navbar variant="custom">
        <Navbar.Brand className="homeArea">
          <span className='area-logo-small'><span className='icon-logo-small' /></span>
        </Navbar.Brand>
        <Navbar.Text className="version">
          v1.0.0
        </Navbar.Text>
        <Navbar.Collapse className="justify-content-end area-header-content">
          <Nav className="timezone">
            <span className="icon-timezone"></span>
            <Navbar.Text className="timezone-text">
              GMT +08:00
            </Navbar.Text>
          </Nav>
          <Navbar.Text>
            <span className="icon-avatar">{ shortFirstChar }</span>
          </Navbar.Text>
        </Navbar.Collapse>        
        <NavDropdown title={name} id="basic-nav-dropdown" className="user-profile">          
          <NavDropdown.Item onClick={this.toResetPasswrod}>
              <span className="icon-resetpassword"></span>
              <span className="area-dropdown-item-text">Reset Password</span>
          </NavDropdown.Item>          
          <NavDropdown.Item onClick={this.toLogout}>
            <span className="icon-signout"></span>
            <span className="area-dropdown-item-text">Sign Out</span>
          </NavDropdown.Item>
        </NavDropdown>
      </Navbar>
   )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    idToken : state.logindReducers.idToken,
    name  : state.logindReducers.account ? state.logindReducers.account.name : 'user name'
  }
}

export default withRouter(connect(
  mapStateToProps,
  { doLogout, forwardForgotPwd, initModalCallback }
)(MainHeader))